import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Validator } from '../../../../utils/Validator.util'
import { IUserLogin, UserLogin, IUserDetails } from '../../../../models/user';
import {
  AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_AUTHORIZE, AUTHORIZATION_SIGNOUT
} from '../../../../store/authorization';
import { namespace } from 'vuex-class';
import { ActivityStatus, UserTypes } from '../../../../common/enums';
import { USER_MODULE_NAMESPACE, USER_INFO } from '../../../../store/user/user-types.store';
// @ts-ignore
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE);
const UserStore = namespace(USER_MODULE_NAMESPACE);

@Component
class TheLoginFormComponent extends Vue {

  dtUserInfo: IUserLogin;
  dtError: string | null;
  dtIsManager: boolean;
  rules: { require: any, email: any };

  @AuthorizationStore.Getter activityStatus: ActivityStatus;
  @AuthorizationStore.Getter isAuthorized: boolean;
  @UserStore.Getter userInfo: IUserDetails;

  @AuthorizationStore.Action(AUTHORIZATION_AUTHORIZE)
  storeAuthorize: (payload: { self: any, userLogin: IUserLogin }) => Promise<any>;
  @AuthorizationStore.Action(AUTHORIZATION_SIGNOUT)
  storeSignOut: (self: any) => Promise<any>;

  @UserStore.Action(USER_INFO)
  storeGetUserInfo: () => Promise<IUserDetails>;

  constructor() {
    super();
    this.dtError = null;
    this.dtUserInfo = new UserLogin({ email: '', password: '' });
    this.dtIsManager = false;
    this.rules = {
      require: (value: string) => !!value || 'Required.',
      email: (value: string) => Validator.IsValidEmail(value) || 'l\'email n\'est pas valide'
    }
  }

  get lblSetting() {
    return {
      ...require('@/locales/button').default,
      ...require('@/locales/login-form').default,
    }
  }

  get coInProcess(): boolean {
    return this.activityStatus === ActivityStatus.Loading;
  }

  get coIsVisible(): boolean {
    this.dtIsManager = this.userInfo.type === UserTypes.Manager;
    if (!this.isAuthorized) {
      localStorage.clear();
    }
    return !this.isAuthorized;
  }

  handleAuthorize() {
    this.dtError = null;
    const self = this;
    this.storeAuthorize({ self, userLogin: self.dtUserInfo })
      .then((token) => {
        return this.storeGetUserInfo()
      })
      .then(user => {
        location.reload()
      })
      .catch(error => {
        this.dtError = error.message;
        this.storeSignOut(self);
      })
  }

  pageRefresh() {
    setTimeout(() => {
      location.reload();
    }, 500);
  }
}
export default TheLoginFormComponent;



// WEBPACK FOOTER //
// ./src/containers/app/components/the-login-form/index.ts